var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4351 74.1523C75.2037 79.7494 68.0468 81.6671 62.4497 78.4356L58.6199 85.069C67.8805 90.4156 79.7219 87.2427 85.0685 77.9821L78.4351 74.1523Z",
    fill: "#7EF2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7019 81.8119C84.2402 94.736 67.7142 99.1641 54.7901 91.7024L50.9604 98.3358C67.548 107.913 88.7584 102.229 98.3353 85.6417L91.7019 81.8119Z",
    fill: "#7EF2F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.602 93.3013L104.969 89.4715C93.2767 109.723 67.3817 116.661 47.1306 104.969L43.3008 111.603C67.2154 125.41 97.7949 117.216 111.602 93.3013Z",
    fill: "#7EF2F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1664 62.4502C54.935 68.0472 56.8527 75.2042 62.4497 78.4356L58.6199 85.069C49.3594 79.7224 46.1865 67.881 51.5331 58.6204L58.1664 62.4502Z",
    fill: "#FFCB00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8997 54.7906C37.438 67.7147 41.8661 84.2407 54.7901 91.7024L50.9604 98.3358C34.3728 88.7589 28.6894 67.5484 38.2663 50.9608L44.8997 54.7906Z",
    fill: "#FFCB00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9995 43.3013L31.6329 47.1311C19.9409 67.3822 26.8795 93.2772 47.1306 104.969L43.3008 111.603C19.3861 97.7954 11.1924 67.2159 24.9995 43.3013Z",
    fill: "#FFCB00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4351 74.1523C81.6666 68.5553 79.7489 61.3984 74.1518 58.1669L77.9816 51.5335C87.2422 56.8801 90.4151 68.7216 85.0685 77.9821L78.4351 74.1523Z",
    fill: "#FFCB00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7019 81.8119C99.1636 68.8878 94.7355 52.3619 81.8114 44.9002L85.6412 38.2668C102.229 47.8436 107.912 69.0541 98.3353 85.6417L91.7019 81.8119Z",
    fill: "#FFCB00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.602 93.3013L104.969 89.4715C116.661 69.2204 109.722 43.3254 89.471 31.6334L93.3008 25C117.215 38.8071 125.409 69.3866 111.602 93.3013Z",
    fill: "#FFCB00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1664 62.4502C61.3979 56.8532 68.5548 54.9355 74.1518 58.1669L77.9816 51.5335C68.7211 46.187 56.8796 49.3599 51.5331 58.6204L58.1664 62.4502Z",
    fill: "#7EF2F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8997 54.7906C52.3614 41.8666 68.8873 37.4384 81.8114 44.9002L85.6412 38.2668C69.0536 28.6899 47.8431 34.3732 38.2663 50.9608L44.8997 54.7906Z",
    fill: "#7EF2F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9995 43.3013L31.6329 47.1311C43.3249 26.8799 69.2199 19.9414 89.471 31.6334L93.3008 25C69.3861 11.1929 38.8066 19.3866 24.9995 43.3013Z",
    fill: "#7EF2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader1);
export default __webpack_public_path__ + "static/media/loader_1.db57876228dbbdc845a3fd09b230ec26.svg";
export { ForwardRef as ReactComponent };